import { Planzone, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function savePlanzone(httpClient: HttpClient) {
  return (name: string, domain: string) =>
    new Promise<Identifiable<Planzone>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<Planzone>>({
          endpoint: `/planzones`,
          method: HttpMethods.POST,
          data: { name, domain },
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { savePlanzone };
